import axios from 'axios'
import 'url-search-params-polyfill'

import setActiveCurrency from './setActiveCurrency'
import apiConfiguration from '../utilities/api/apiConfiguration'

export const FETCH_EXCHANGE_RATES_BEGIN   = 'FETCH_EXCHANGE_RATES_BEGIN'
export const FETCH_EXCHANGE_RATES_SUCCESS = 'FETCH_EXCHANGE_RATES_SUCCESS'
export const FETCH_EXCHANGE_RATES_FAILURE = 'FETCH_EXCHANGE_RATES_FAILURE'

export const fetchExchangeRatesBegin = () => ({
	type: FETCH_EXCHANGE_RATES_BEGIN,
})

export const fetchExchangeRatesSuccess = exchangeRates => ({
	type: FETCH_EXCHANGE_RATES_SUCCESS,
	payload: exchangeRates
})

export const fetchExchangeRatesError = error => ({
	type: FETCH_EXCHANGE_RATES_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchExchangeRates(currencyCode) {
	return (dispatch) => {
		let clientId = null

		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			clientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		// URL Params
		let urlParams = {
			base: currencyCode,
			clientId: clientId
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Base API path
		const exchangeApi = process.env.REACT_APP_FLOW_ENDPOINT_URL + '/api/forex?' + fetchQuery.toString()

		dispatch(fetchExchangeRatesBegin())
		return axios.get(exchangeApi, apiConfiguration())
			.then((response) => {
				dispatch(fetchExchangeRatesSuccess(response.data.rates))
			})
			.then(() => {
					dispatch(setActiveCurrency(currencyCode))
			})
			.catch(error => {
				dispatch(fetchExchangeRatesError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchExchangeRates.js